module.exports = __webpack_public_path__ + "img/booster.93dc97d3.svg";